import type {FC} from 'react';

import styled, {css} from 'styled-components';

import {SwitchEnvButton} from '@yourcoach/shared/components/SwitchEnvButton';
import {View} from '@yourcoach/shared/uikit/View';

const Container = styled(View)<Pick<Props, 'isMenuOpened'>>`
  width: 100%;
  align-items: flex-end;
  transition: transform 0.3s;
  transform: translateX(100px);
  padding-block-end: 30px;

  ${p =>
    p.isMenuOpened &&
    css`
      transform: translateX(0);
    `}
`;

const SwitchEnvContainer = styled.div`
  padding-inline: 25px;
  display: flex;
  flex-direction: column;
  justify-items: stretch;
  width: 100%;
`;

type Props = {
  isMenuOpened: boolean;
};

export const MainMenuFooter: FC<Props> = ({isMenuOpened}) => {
  return (
    <Container isMenuOpened={isMenuOpened}>
      <SwitchEnvContainer>
        <SwitchEnvButton isCollapsed={!isMenuOpened} />
      </SwitchEnvContainer>
    </Container>
  );
};
